import script from "./ProductAddOns.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductAddOns.vue?vue&type=script&setup=true&lang=ts"

import "./ProductAddOns.vue?vue&type=style&index=0&id=166b9bac&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-166b9bac"]])

export default __exports__